import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../lang/LangEnum';
import { useTranslation } from '../translation/TranslationContext';

const OrderActiveTitle = () => {
  const { translate } = useTranslation();

  return (
    <Typography align="center" color="textPrimary" variant="h6">
      {translate(LangEnum.ACTIVE_ORDER_ORDER_BOOK)}
    </Typography>
  );
};

export default OrderActiveTitle;
